import styles from './Article.module.scss';

type ArticleConclusionProps = {
  text: string,
  title: string,
};
const ArticleConclusion = ({ text, title }: ArticleConclusionProps) => (
  <div className={styles.conclusion}>
    {title && <h6 className={styles.conclusion__title}>{title}</h6>}
    <p className={styles.conclusion__text}>{text}</p>
  </div>
);

export default ArticleConclusion;
